












































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Smokecrib from "../../../store/entities/smokecrib";
class PagefactoryRequest{
  cId:Number;
  ftId:Number;
  wId:Number;
}
@Component
export default class EditSmokecrib extends AbpBase {
  pagefactoryrequest: PagefactoryRequest = new PagefactoryRequest();
  @Prop({ type: Boolean, default: false }) value: boolean;
  created() {}
  smokecrib: Smokecrib = new Smokecrib();
  save() {
    (this.$refs.smokecribForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "smokecrib/update",
          data: this.smokecrib,
        });
        (this.$refs.smokecribForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  get factory(){
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.filterlist;
  }
   get floor() {
    return this.$store.state.floor.filterlist;
  }
  get threshold(){
    //console.log(this.$store.state.threshold.list);
    return this.$store.state.threshold.list;
  }
  cancel() {
    (this.$refs.smokecribForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.smokecrib = Util.extend(true, {}, this.$store.state.smokecrib.editSmokecrib);
      //console.log(this.smokecrib);
      this.selfactory(this.smokecrib.ftId);
      this.selwarehouse(this.smokecrib.wId);
    }
  }
   smokecribRule = {
    ftId: [{type:"number",required: true, message: "请选择库区", trigger: "change" }],
    wId: [{type:"number",required: true, message: "请选择库房", trigger: "change" }],
    mac: [{ required: true, message: "请填写SN号", trigger: "blur" }],
    fId: [{type:"number",required: true, message: "请选择楼层", trigger: "change" }],
    LocationName: [{ required: true, message: "请填写位置", trigger: "blur" }],
    number: [{transform: (value) => String(value), required: true, message: "请填写位置编号", trigger: "blur" }],
    tId:[{ type:"number",required: true, message: "请选择阈值方案", trigger: "change" }],
    yieldly: [{required: true, message: "请填写烟草产地", trigger: "blur" }],
    year: [{required: true, message: "请填写烟草年份", trigger: "blur" }],
    grade: [{required: true, message: "请填写烟草等级", trigger: "blur" }],
  };
  selfactory(value:Number){
    this.pagefactoryrequest.ftId = value;
    this.getwarehouse();
      this.getfloor();
  }
  selwarehouse(value:Number){
    this.pagefactoryrequest.wId = value;
    this.getfloor();
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getfilter",
      data: this.pagefactoryrequest,
    });
  }
  async getfloor() {
    //楼层
    //filters
    await this.$store.dispatch({
      type: "floor/getfilter",
      data: this.pagefactoryrequest,
    });
  }
}
